import {ErrorHandler, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {IonicApp, IonicErrorHandler, IonicModule} from 'ionic-angular';
import {MyApp} from './app.component';
import {Geolocation} from '@ionic-native/geolocation';

import {AboutPage} from '../pages/about/about';
import {MapPage} from '../pages/map/map';

import {StatusBar} from '@ionic-native/status-bar';
import {SplashScreen} from '@ionic-native/splash-screen';
import {YagaModule} from '@yaga/leaflet-ng2';
import {SitePage} from "../pages/site/site";
import {ListSitePage} from "../pages/list-site/list-site";
import {SiteFormComponent} from "../components/site-form/site-form";
import {SectorPage} from "../pages/sector/sector";
import {DataProvider} from '../providers/data/data';
import {ToastProvider} from '../providers/toast/toast';
import {RestProvider} from '../providers/rest/rest';
import {HttpModule} from "@angular/http";
import {HttpClientModule} from "@angular/common/http";
import {QuillModule} from "ngx-quill";
import {PhotosViewerPage} from "../pages/photos-viewer/photos-viewer";
import {PhotosRoutesViewerPage} from "../pages/photos-routes-viewer/photos-routes-viewer";
import {BookPage} from "../pages/book/book";
import {EnvironmentalAlertPage} from "../pages/environmental-alert/environmental-alert";
import {IonicStorageModule} from "@ionic/storage";
import {SettingsPage} from "../pages/settings/settings";
import {ComponentsModule} from '../components/components.module';
import {BookPageModule} from '../pages/book/book.module';
import {EnvironmentalAlertPageModule} from '../pages/environmental-alert/environmental-alert.module';
import {ListSitePageModule} from '../pages/list-site/list-site.module';
import {SitePageModule} from '../pages/site/site.module';
import {SectorPageModule} from "../pages/sector/sector.module";
import {PhotosViewerPageModule} from "../pages/photos-viewer/photos-viewer.module";
import {PhotosRoutesViewerPageModule} from "../pages/photos-routes-viewer/photos-routes-viewer.module";
import {SettingsPageModule} from "../pages/settings/settings.module";
import { NetworkProvider } from '../providers/network/network';
import {ListRoutesSectorPageModule} from "../pages/list-routes-sector/list-routes-sector.module";
import {ListRoutesSectorPage} from "../pages/list-routes-sector/list-routes-sector";
import {ContactPage} from "../pages/contact/contact";
import {ContactPageModule} from "../pages/contact/contact.module";


@NgModule({
  declarations: [
    MyApp,
    AboutPage,
    MapPage,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp, {tabsHideOnSubPages: true}),
    IonicStorageModule.forRoot(),
    HttpModule,
    HttpClientModule,
    YagaModule,
    QuillModule,
    ComponentsModule,
    BookPageModule,
    EnvironmentalAlertPageModule,
    ListSitePageModule,
    SitePageModule,
    SectorPageModule,
    PhotosViewerPageModule,
    PhotosRoutesViewerPageModule,
    SettingsPageModule,
    ContactPageModule,
    ListRoutesSectorPageModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    AboutPage,
    MapPage,
    SitePage,
    SectorPage,
    ListSitePage,
    SiteFormComponent,
    PhotosViewerPage,
    PhotosRoutesViewerPage,
    EnvironmentalAlertPage,
    ListRoutesSectorPage,
    BookPage,
    SettingsPage,
    ContactPage],
  providers: [
    StatusBar,
    SplashScreen,
    Geolocation,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    DataProvider,
    ToastProvider,
    RestProvider,
    NetworkProvider,
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts